export default {"src":"/_next/static/media/contactForm.fa51e925.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};